module.exports = __webpack_public_path__ + "img/left.04788491.png";